module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lg-page"
  }, [_c('div', {
    staticClass: "lg-shell"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "lg-card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "lg-header"
  }, [_c('span', {
    staticClass: "lg-icon"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "10 17 15 12 10 7"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "15",
      "y1": "12",
      "x2": "3",
      "y2": "12"
    }
  })])]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), (_vm.checkingRememberedSession) ? _c('div', {
    staticClass: "lg-checking"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "lg-sk-field sk-shimmer"
  }), _vm._v(" "), _c('div', {
    staticClass: "lg-sk-field sk-shimmer"
  }), _vm._v(" "), _c('div', {
    staticClass: "lg-sk-button sk-shimmer"
  }), _vm._v(" "), _c('p', {
    staticClass: "lg-checking-text"
  }, [_vm._v("Checking saved session...")])]) : _c('form', {
    staticClass: "lg-form",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        return _vm.handleSubmit($event)
      }
    }
  }, [(_vm.error) ? _c('div', {
    staticClass: "lg-alert",
    domProps: {
      "innerHTML": _vm._s(_vm.error)
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.trainer) ? _c('div', {
    staticClass: "lg-alert"
  }, [_c('strong', [_vm._v("Failed to sign in!")]), _vm._v(" Only trainers are allowed to access LiveRun Console.")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "lg-field"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "lg-input-wrap",
    class: {
      'lg-input-wrap--danger': _vm.errors.has('username')
    }
  }, [_c('svg', {
    staticClass: "lg-input-icon",
    attrs: {
      "width": "15",
      "height": "15",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M20 21a8 8 0 0 0-16 0"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "12",
      "cy": "7",
      "r": "4"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.username),
      expression: "user.username"
    }],
    staticClass: "lg-input",
    attrs: {
      "id": "username",
      "data-vv-rules": "required",
      "type": "text",
      "name": "username",
      "autocomplete": "username",
      "required": ""
    },
    domProps: {
      "value": (_vm.user.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "username", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('username')),
      expression: "errors.has('username')"
    }],
    staticClass: "lg-error"
  }, [_vm._v("Fill in the username")])]), _vm._v(" "), _c('div', {
    staticClass: "lg-field"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "lg-input-wrap",
    class: {
      'lg-input-wrap--danger': _vm.errors.has('password')
    }
  }, [_c('svg', {
    staticClass: "lg-input-icon",
    attrs: {
      "width": "15",
      "height": "15",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('rect', {
    attrs: {
      "x": "3",
      "y": "11",
      "width": "18",
      "height": "10",
      "rx": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7 11V7a5 5 0 0 1 10 0v4"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "lg-input",
    attrs: {
      "id": "password",
      "data-vv-rules": "required",
      "type": "password",
      "name": "password",
      "autocomplete": "current-password",
      "required": ""
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password')),
      expression: "errors.has('password')"
    }],
    staticClass: "lg-error"
  }, [_vm._v("Fill in the password!")])]), _vm._v(" "), _c('div', {
    staticClass: "lg-options"
  }, [_c('div', {
    staticClass: "lg-toggle-row"
  }, [_c('lv-toggle', {
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
      }
    },
    model: {
      value: (_vm.rememberMe),
      callback: function($$v) {
        _vm.rememberMe = $$v
      },
      expression: "rememberMe"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "lg-toggle-label"
  }, [_vm._v("Remember Me")]), _vm._v(" "), _c('span', {
    staticClass: "lg-toggle-badge"
  }, [_vm._v(_vm._s(_vm.rememberMe ? 'On' : 'Off'))])], 1), _vm._v(" "), _c('router-link', {
    staticClass: "lg-forgot",
    attrs: {
      "slot": "actions",
      "to": ""
    },
    slot: "actions"
  }, [_vm._v("Forgot password?")])], 1), _vm._v(" "), _c('button', {
    staticClass: "lg-submit",
    attrs: {
      "id": "sign-in",
      "disabled": _vm.signingIn
    }
  }, [(!_vm.signingIn) ? _c('svg', {
    attrs: {
      "width": "13",
      "height": "13",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.1",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M5 12h14"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12 5l7 7-7 7"
    }
  })]) : _c('span', {
    staticClass: "lg-spinner"
  }), _vm._v("\n          " + _vm._s(_vm.signingIn ? 'Signing in...' : 'Sign In') + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lg-brand"
  }, [_c('img', {
    staticClass: "lg-logo",
    attrs: {
      "src": require("../../assets/logo.png"),
      "alt": "LiveRun"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "lg-env-badge"
  }, [_vm._v("Console")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pg-title-row"
  }, [_c('div', [_c('h1', {
    staticClass: "pg-title"
  }, [_vm._v("Sign in")]), _vm._v(" "), _c('p', {
    staticClass: "pg-title-sub"
  }, [_vm._v("Access trainer tools, live race controls and console settings")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "lg-title"
  }, [_vm._v("Trainer Access")]), _vm._v(" "), _c('p', {
    staticClass: "lg-subtitle"
  }, [_vm._v("Use your LiveRun trainer credentials to continue")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lg-sk-row"
  }, [_c('div', {
    staticClass: "lg-sk-icon sk-shimmer"
  }), _vm._v(" "), _c('div', {
    staticClass: "lg-sk-copy"
  }, [_c('div', {
    staticClass: "lg-sk-line lg-sk-line--wide sk-shimmer"
  }), _vm._v(" "), _c('div', {
    staticClass: "lg-sk-line sk-shimmer"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "lg-label",
    attrs: {
      "for": "username"
    }
  }, [_vm._v("Username "), _c('span', {
    staticClass: "lg-required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "lg-label",
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Password "), _c('span', {
    staticClass: "lg-required"
  }, [_vm._v("*")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-81a18104"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login/Login.vue
// module id = 1738
// module chunks = 2